export const GITHUB_URL = 'https://github.com/adamslack'; 
export const LINKEDIN_URL = 'https://linkedin.com/in/adam-slack'
export const TWITTER_URL = 'https://twitter.com/Hapax_xyz/'
export const HAPAX_URL = 'https://hapax.xyz';
